/* Publish by EComposer at 2026-10-28 01:20:00*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a8kqmtqk8x"]=  window.__ectimmers["ecom-a8kqmtqk8x"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-a8kqmtqk8x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a8kqmtqk8x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fgnpmc7e4sr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fgnpmc7e4sr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bd521ibuyz5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bd521ibuyz5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-janig6p0128').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-janig6p0128', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2cssz0q1a1q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2cssz0q1a1q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5npjsk0giu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5npjsk0giu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0nf95kdhlsz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0nf95kdhlsz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nzz53wnjakb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nzz53wnjakb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8xj3lecacfu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8xj3lecacfu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-11y76sgswii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-11y76sgswii', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pjlnxqozbte').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pjlnxqozbte', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-37j6szkufna').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-37j6szkufna', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0qze249rdce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0qze249rdce', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-db6bocnvisg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-db6bocnvisg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ohatr8verkn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ohatr8verkn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8azs8mfj65').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8azs8mfj65', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wsw8a1xs3sk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wsw8a1xs3sk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n8zdfvvf7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n8zdfvvf7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24nwxbdmrdp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24nwxbdmrdp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mmkhbatnpy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mmkhbatnpy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g3hgcg9f8l4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g3hgcg9f8l4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-smc9rp4sjko').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-smc9rp4sjko', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xahjvww6em').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xahjvww6em', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zo1xc08qlri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zo1xc08qlri', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yi7qijlkv2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yi7qijlkv2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y4iqoxohwcb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y4iqoxohwcb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r6p4811vdo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r6p4811vdo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7epeunqc49r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7epeunqc49r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4dwvgfrp8dw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4dwvgfrp8dw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wqsbn6wgyek').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wqsbn6wgyek', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uw1i33as32').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uw1i33as32', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-33xnk0dvnaa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-33xnk0dvnaa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3jd6xc6xfvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3jd6xc6xfvb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ssl5neh1hw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ssl5neh1hw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-si3yla6bpg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-si3yla6bpg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cyk8srbef0d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cyk8srbef0d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0w06j6jzr4jr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0w06j6jzr4jr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znnlxh6s69r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znnlxh6s69r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4o9rj155oup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4o9rj155oup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzxjod1tml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzxjod1tml', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sguuack5mp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sguuack5mp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-it1a3jc8x1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-it1a3jc8x1m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uc8yfopiqm9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uc8yfopiqm9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pqynkjo2xd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pqynkjo2xd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tfkm3oy0rks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tfkm3oy0rks', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gnio13bn6lo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gnio13bn6lo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rt0j0oui5x8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rt0j0oui5x8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2xb8x0m7j35').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2xb8x0m7j35', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mcp31847fob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mcp31847fob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mlspi1s5kt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mlspi1s5kt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2lefux565m5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2lefux565m5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5nqchi8cgs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5nqchi8cgs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e1hm6twytr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e1hm6twytr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-62864nciwks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-62864nciwks', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-60fmtcb2zxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-60fmtcb2zxl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n9fimlhxlq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n9fimlhxlq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-psh9kpdjky').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-psh9kpdjky', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-22umfgncy77').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-22umfgncy77', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nymbt60b14h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nymbt60b14h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xluishf6hba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xluishf6hba', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-caec9lg7vib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-caec9lg7vib', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8cj7qaoxyyp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8cj7qaoxyyp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wcrulub43y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wcrulub43y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ofnwo796o59').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ofnwo796o59', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zot4uco7nng').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zot4uco7nng', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sws0uo7e52o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sws0uo7e52o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t7b8jgvl1qh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t7b8jgvl1qh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nks3ep7zv6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nks3ep7zv6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kce9m9jarza').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kce9m9jarza', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mgafz3smht').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mgafz3smht', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a646gqv325a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a646gqv325a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-foi3ecukpbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-foi3ecukpbk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lleoxc67ig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lleoxc67ig', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i5l2ie20lff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i5l2ie20lff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2x1mpwq18s7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2x1mpwq18s7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n652ch00f6o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n652ch00f6o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f9c2qqj3e4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f9c2qqj3e4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-11yh6mb6o04').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-11yh6mb6o04', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sew56y1tfxb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sew56y1tfxb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99bgmfribc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99bgmfribc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ht5y95fri7s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ht5y95fri7s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s0k2jszwg99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s0k2jszwg99', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwbos1plezu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwbos1plezu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8e3vm6alv2g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8e3vm6alv2g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ry1dyz0jax').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ry1dyz0jax', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gowrr15e107').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gowrr15e107', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6sc9xrrpzsr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6sc9xrrpzsr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gy76c1jswii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gy76c1jswii', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fv6ob7v4p97').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fv6ob7v4p97', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l9ypxztkgvc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l9ypxztkgvc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8m68w71ufmn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8m68w71ufmn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o7bmcj1thxd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o7bmcj1thxd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g1qw8ol5tr7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g1qw8ol5tr7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bf2dkjpohhb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bf2dkjpohhb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z8bmohuvgzo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z8bmohuvgzo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kvb8r1wa7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kvb8r1wa7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-15v4ulzpu4d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-15v4ulzpu4d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r14a4o61fi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r14a4o61fi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1f3hdyyemmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1f3hdyyemmp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lbf87aocux').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbf87aocux', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s07d4cq9i8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s07d4cq9i8g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oextszjx10n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oextszjx10n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r195qgmkedi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r195qgmkedi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lfbmbd1szf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lfbmbd1szf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hprxljz4sgm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hprxljz4sgm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-btunfcpkn7v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-btunfcpkn7v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e901iamcvvs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e901iamcvvs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a7mn4ugn9n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a7mn4ugn9n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3lbmqnwwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3lbmqnwwd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ahtciz6cwar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahtciz6cwar', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-id6zkrxk92a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-id6zkrxk92a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-faea9hoyzti').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-faea9hoyzti', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-67mtdg4ryoj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-67mtdg4ryoj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lnl08am9s99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lnl08am9s99', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v53d07ujdj8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v53d07ujdj8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-75walsych4u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-75walsych4u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2tmzefw0bg3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2tmzefw0bg3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nnypzalujt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nnypzalujt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0qqxti2gwqyd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0qqxti2gwqyd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptwryu2dzqi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptwryu2dzqi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lkub8hsimvt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lkub8hsimvt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2kr1a3rjqb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2kr1a3rjqb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0qappdmfaa3j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0qappdmfaa3j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ogsp3il98ur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ogsp3il98ur', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-knzbg03gqw8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-knzbg03gqw8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pxajxuqi8j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pxajxuqi8j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jdsvm3jt2je').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jdsvm3jt2je', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9kajlgzyjcw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9kajlgzyjcw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e5yeidc3pa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e5yeidc3pa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s3z5yuwijg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s3z5yuwijg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jmmwiqp0z38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jmmwiqp0z38', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-40j8npj7wmx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-40j8npj7wmx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s3z1q53tz8i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s3z1q53tz8i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l8s4tyu72m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l8s4tyu72m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1brgvzzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1brgvzzb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zdx3qzvk8mb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zdx3qzvk8mb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rwq6x9n18d9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rwq6x9n18d9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q651phf59cj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q651phf59cj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4c66tf2v216').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4c66tf2v216', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p47o4nxmwrb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p47o4nxmwrb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ykkxjb9z7i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ykkxjb9z7i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-shrvc3419x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-shrvc3419x', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-z8t09attpja"]=  window.__ectimmers["ecom-z8t09attpja"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-z8t09attpja"]["ftge5x744"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-z8t09attpja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z8t09attpja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-73tb25gq2q6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-73tb25gq2q6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8gemunxciiq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8gemunxciiq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-75lbi8sd135').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-75lbi8sd135', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vj2xdmfgieo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vj2xdmfgieo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ophr6i3zdb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ophr6i3zdb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4zy4yo9wdbc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4zy4yo9wdbc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2hplgjd0wcu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2hplgjd0wcu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-irvzn5c385').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-irvzn5c385', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jh5joth01v8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jh5joth01v8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-leu3kaw7wo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-leu3kaw7wo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5x8bcxnq5lr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5x8bcxnq5lr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gzmmapbecdd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gzmmapbecdd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bezbtz1uka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bezbtz1uka', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b5a4wmptfik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b5a4wmptfik', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6175s3fsbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6175s3fsbk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w95tdug0l7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w95tdug0l7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xo4qkift0pk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xo4qkift0pk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jb8turrnaz9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jb8turrnaz9', settings: {"link":"lightbox"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2mg4pcxeeo6"]=  window.__ectimmers["ecom-2mg4pcxeeo6"] || {};
var $,E,I,D,P,j;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,s=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(I=this.settings.disable_auto_close__mobile)!=null?I:!1,n=(D=this.settings.scroll_on_mobile)!=null?D:!1,r=(P=this.settings.disable_effect)!=null?P:!1,a=(j=this.settings.close_all)!=null?j:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(T){const F=T.getBoundingClientRect();return F.top>=0&&F.left>=0&&F.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&F.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(T){return o&&T<768||s&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const F=T.style.transition;T.style.transition="none",T.style.height="auto";const H=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=F,requestAnimationFrame(()=>{const R=r?"auto":e?H+"px":"auto";T.style.height=R})}function y(T){T.classList.remove("ecom-item-active");const F=T.querySelector(":scope > .ecom-accordion__body");F&&(r||(F.style.height=F.scrollHeight+"px",F.offsetHeight),requestAnimationFrame(()=>{F.style.height="0px"}))}function v(T){let F=0;if(T.offsetParent)do F+=T.offsetTop;while(T=T.offsetParent);return F}function w(T){const F=Math.max(0,T),H=window.pageYOffset||document.documentElement.scrollTop,R=F-H;if(R===0)return;const K=300;let W=null;function G(se){W||(W=se);const te=Math.min((se-W)/K,1),Y=te<.5?2*te*te:1-Math.pow(-2*te+2,2)/2;window.scrollTo(0,H+R*Y),te<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function S(T){w(v(T)-100)}function C(T,F=!1){T.forEach((H,R)=>{const K=H.parentNode,W=K.querySelector(":scope > .ecom-accordion__body");!r&&W&&W.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");W&&!a&&(F&&R===0||G)&&requestAnimationFrame(()=>{W.style.height=W.scrollHeight+"px"}),H.onclick=function(se){var ue,_e;if(se.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const te=m(),Y=this.parentNode,pe=Y.parentNode,ce=pe.querySelectorAll(":scope > .ecom-accordion__item"),he=Array.from(ce).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const V=this.classList.contains("ecom-item-active"),X=_(te);if(V)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ce.forEach(y),he.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(ce.forEach(y),he.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),H.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(ue=we.parentElement)==null?void 0:ue.closest)==null?void 0:_e.call(ue,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const Q=this,ge=n||te>1024;function ee(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(Q)&&S(Q)}if(ge&&!r){let we;const Ae=function(Ee){Ee.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},50))};pe.addEventListener("transitionend",Ae),setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},600)}else requestAnimationFrame(()=>{setTimeout(ee,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function x(){const T=window.location.hash;if(T){const F=t.querySelector(`[data-target="${T}"]`);if(F){F.click(),F.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=F.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(x,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",x,!1)

                    });
                    
                        document.querySelectorAll('.ecom-2mg4pcxeeo6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2mg4pcxeeo6', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ox00b3tad8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ox00b3tad8g', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hgho21lub3k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hgho21lub3k', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zldsa65wzw8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zldsa65wzw8', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n84jbi77h7i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n84jbi77h7i', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yoitqd6yc6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yoitqd6yc6a', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uhk8fai9u4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uhk8fai9u4', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6o1t795h3ct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6o1t795h3ct', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p6ep9utfqj8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p6ep9utfqj8', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-betfaryay2c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-betfaryay2c', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-an3h59dm3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-an3h59dm3b', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4vbh1v61qb8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4vbh1v61qb8', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fjjnuwhtkv5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fjjnuwhtkv5', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g6f57l73996').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g6f57l73996', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3z3g2r6y6d7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3z3g2r6y6d7', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4vp29egxavn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4vp29egxavn', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-n03g03649"]=  window.__ectimmers["ecom-n03g03649"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-n03g03649"]["mpo2s0v1z"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-n03g03649').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n03g03649', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fydwpljwf7b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fydwpljwf7b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tvokrmw0ms').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tvokrmw0ms', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kil4a63t27o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kil4a63t27o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vlvbzzuia3k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vlvbzzuia3k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ecn2agi93fv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ecn2agi93fv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p73ek4jylss').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p73ek4jylss', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zxgozddg4rp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zxgozddg4rp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gw92sc3c7rb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gw92sc3c7rb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fgy031mdsfc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fgy031mdsfc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lpn1zszihes').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lpn1zszihes', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t7iiw041iu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t7iiw041iu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ryb7j4swq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ryb7j4swq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ppgzhl9g74').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ppgzhl9g74', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e38qum56l4g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e38qum56l4g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fs1j6gh00z7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fs1j6gh00z7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jnff886n6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jnff886n6a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-np9u8lm034n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-np9u8lm034n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1qkmu9sg05n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1qkmu9sg05n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7t11is7mh5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7t11is7mh5s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wcibki3vt9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wcibki3vt9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f3yxhwbf7q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f3yxhwbf7q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ugedaw2s2nb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ugedaw2s2nb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rh0ipkgd3mh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rh0ipkgd3mh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nwnsnzq8cuo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nwnsnzq8cuo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0cwpbt7c398t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0cwpbt7c398t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qfri1b3ml9h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qfri1b3ml9h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-96tdds0g4ot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-96tdds0g4ot', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zfhyku5n11').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zfhyku5n11', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-s4c6eso8ktn"]=  window.__ectimmers["ecom-s4c6eso8ktn"] || {};
if(!this.settings||!this.$el||this.isLive)return;const t=this.$el;let e=t.querySelectorAll('script:not([type="application/json"])');e.length>0&&e.forEach(function(i){let s=document.createElement("script");s.type="text/javascript",s.innerText=i.innerText,i.src&&(s.src=i.src),t.appendChild(s),i.remove()})

                    });
                    
                        document.querySelectorAll('.ecom-s4c6eso8ktn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s4c6eso8ktn', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}